import axiosInstance from './../axiosInstance';
import { buildParams } from '../buildParams';

/**
 * @name getEventPersonnel
 * @desc Get events personnel.
 * @param {string} eventID
 * @param {string} partnerID
 * @param {object} params
 */
export const getEventPersonnel = (eventID, partnerID, params = {})=> {
  return axiosInstance.get(`events/${eventID}/partners/${partnerID}/personnel`, { params: buildParams(params) });
};

/**
 * @name updateEventPerson
 * @desc create / update event person
 */
export const updateEventPerson = (eventID, data) => {
  var URL = data.personID ? `events/${eventID}/persons/${data.personID }` : `events/${eventID}/persons/`;
  return axiosInstance.post(URL, data);
}

/**
 * @name deleteEventPerson 
 * @desc Delete person from current event
 */
export const deleteEventPerson = ({ eventID, partnerID, personID }) => {  
  const URL = `events/${eventID}/partners/${partnerID}/persons/${personID}/delete`;
  return axiosInstance.post(URL);
};

/**
 * @name getEventGuests
 * @desc Get partners events guests.
 * @param {string} eventID
 * @param {string} partnerID
 * @param {object} params
 */
export const getEventGuests = (eventID, partnerID, params = {})=> {
  return axiosInstance.get(`events/${eventID}/partners/${partnerID}/guests`, { params: buildParams(params) });
};

/**
 * @name getEventPersonMeta
 * @desc Get Event related person meta
 */
export const getEventPersonMeta = () => {
  return axiosInstance.get(`persons/meta`);
}

/**
 * @name sendBadge
 * @desc Send a persons badge to a specific email address.
 * @param {string} eventID
 * @param {string} personID
 * @param {object} recipient
 */
export const sendBadge = (eventID, personID, recipient)=> {
  return axiosInstance.post(`events/${eventID}/persons/${personID}/sendBadge`, recipient);
};

export const checkIfPersonExists = (eventID, email) => {
  return axiosInstance.post(`events/${eventID}/persons/emailExists`, { email });
};

export const linkPersonToEventPersons = ({ eventID, partnerID, personID }) => {
  const data = {
    eventID,
    partnerID,
    personID,
    personType: 3 // 3 === partner, 0 === guest
  }
  return axiosInstance.post(`events/${eventID}/partners/${partnerID}/persons/${personID}`, data);
};